import React from 'react';

import * as styles from './styles.css';
import Box from '../../../../../Components/UI/Box';
import ContentLoaderBox from '../../../LoadingSkeleton/ContentLoaderBox';

interface SkeletonButtonProps {
  textWidth: number;
}

const SkeletonButton: React.FC<SkeletonButtonProps> = ({ textWidth }) => (
  <Box className={styles['skeleton-button']} display="flex">
    <ContentLoaderBox marginVertical={3} marginHorizontal={4} height={24} width={200}>
      <rect x="0" y="0" rx="6" ry="6" width="32" height="24" />
      <rect x="38" y="3" rx="6" ry="6" width={textWidth} height="18" />
    </ContentLoaderBox>
  </Box>
);

const MethodsSkeleton: React.FC = () => {
  return (
    <>
      <SkeletonButton textWidth={75} />
      <SkeletonButton textWidth={120} />
      <SkeletonButton textWidth={40} />
      <SkeletonButton textWidth={110} />
    </>
  );
};

export default MethodsSkeleton;
